import { useCallback } from 'react';
import { FormatterProps } from '../types';
import { css } from '@linaria/core';
import { isCtrlDown } from '../utils';

export const rowIndexCellClassName = css`
font-size: 12px;
cursor: pointer;
display: flex;
align-items: center;
justify-content: flex-end;
padding-right: 5px;
`

const selectedClassName = css`
    background: var(--row-selected-hover-background-color);
    color: var(--color);
`


interface IProps extends FormatterProps {

}

const RowIndexCellFormatter: React.FC<IProps> = function (props) {
    const { isRowSelected, onRowSelectionChange, rowIdx } = props;

    const onClick = useCallback((e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        onRowSelectionChange(!isRowSelected, e.nativeEvent.shiftKey, isCtrlDown(e));
    }, [isRowSelected, onRowSelectionChange])
    return <div
        onClick={onClick}
        className={`${rowIndexCellClassName} ${isRowSelected ? selectedClassName : ''}`}
    >
        {rowIdx + 1}
    </div>
}


export default RowIndexCellFormatter;